import React, { Profiler } from "react";
import useClientMetrics from "../hooks/useClientMetrics";
import { Helmet } from "react-helmet-async";
import AppShell from "../components/elements/AppShell";
import NoSSR from "../app/NoSSR";
import CheckoutAlternativeFaresInner from "../components/elements/CheckoutAlternativeFares/CheckoutAlternativeFaresInner";

const CheckoutAlternativeFares = () => {
  const { trackRenderTime } = useClientMetrics();

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <Helmet>
        <meta property="webview:header" content="regular" />
        <meta property="webview:title" content={""} />
        <meta property="webview:button_action" content="close" />
      </Helmet>

      <AppShell noPadding noMainWrapper>
        <NoSSR>
          <CheckoutAlternativeFaresInner />
        </NoSSR>
      </AppShell>
    </Profiler>
  );
};

export default CheckoutAlternativeFares;
